import { useCustomerSessionStore } from '~/modules/customer/auth/customer-session.store'
import { getRealmCookieNames } from '~/shared-kernel/infrastructure/session/realm-session'

/** Exposes the customer session to shells outside the customer product without cross-product imports. */
export default defineNuxtPlugin(() => {
  const session = useCustomerSessionStore()
  const cookies = getRealmCookieNames('customer')
  // Only the server can read the httpOnly session cookies; the payload carries the hint so the
  // first paint already shows the signed-in chrome instead of swapping it in after `/me`.
  const sessionHint = useState('customer-session-hint', () => import.meta.server
    && Boolean(useCookie(cookies.accessToken).value || useCookie(cookies.refreshToken).value))
  // A signed-out transition (logout, discarded session) ends the hint for the rest of the visit.
  watch(() => session.principal, principal => { if (!principal) sessionHint.value = false })

  return {
    provide: {
      customerAccount: {
        principal: computed(() => session.principal),
        signedIn: computed(() => Boolean(session.principal) || sessionHint.value),
        // Background load: public shells must not raise the full-screen loading overlay for every visitor.
        hydrateInBackground: async () => {
          try {
            return session.hasResolvedIdentityState ? session.principal : await session.refreshPrincipal()
          } finally {
            sessionHint.value = Boolean(session.principal)
          }
        },
        logout: () => session.logout()
      }
    }
  }
})
